import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import appRoutes from "../../routes/appRoutes";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import SuccessMsg from "../../components/successMsg";

const ForgotPasswordForm = props => {
  const formik = useFormik({
    initialValues: {
      email: ""
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .min(7, "Email must be of minimum length 7")
        .email("Please provide a valid email address")
        .required("Please enter the email address")
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });
  return (
    <form
      className="d-flex flex-column align-items-center"
      onSubmit={formik.handleSubmit}
    >
      <p style={{ fontSize: "14px" }}>
        A link will be sent to your email address so you can reset your password
      </p>
      <ICInput
        id="email"
        name="email"
        type="text"
        label="Email Address *"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.email}
        error={formik.touched.email && formik.errors.email ? true : false}
        helperText={
          formik.touched.email && formik.errors.email ? formik.errors.email : ""
        }
      />
      <br />
      <Button className="mt-2" title="Submit" type="submit" />
      <br />
      <p>
        <Link className="custom-link" to={appRoutes.login}>
          Back to Login
        </Link>
      </p>
      <Error>{props.serverErrorMsg}</Error>
      <SuccessMsg>{props.successMsg}</SuccessMsg>
    </form>
  );
};

export default ForgotPasswordForm;

ForgotPasswordForm.defaultProps = {
  serverErrorMsg: "",
  successMsg: ""
};

ForgotPasswordForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
  successMsg: PropTypes.string
};
